const PDAM_URL = `${process.env.API_V4_HOST}/pdam`;

export const getPdamTransaction = ($axios, transactionId) => $axios.$get(`${PDAM_URL}/transactions/${transactionId}`);
